<section>
    <app-shared-loading *ngIf="loading"></app-shared-loading>
    <div class="general-title">
        <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
    </div>
    <app-return-methods [itsMobileCtrl]="true" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
    </app-return-methods>
    <ng-container *ngIf="sinpeMovilCheckoutFf else oldSinpeMovil">
      <div class="contentBox" style="height:670px !important">
        <div class="center col-3">
            <div class="info-logo-container">
                <img [src]="information.logo" class="payment_method_no_interactive __method_brands" alt="sinpe-logo" />
            </div>
        </div>
        <div class="col-7">
            <div class="methodInfo">
                <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD"
                    (RT)="changeMethod()">
                </app-return-methods>
                <h1>{{ 'transferTitle' | translation | async }}</h1>
                <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
                <div class="steps">
                    <app-counter-item [number]="1">
                        <p innerHTML="{{ 'sinpe-Movil-Step-One' | translation | async }}"></p>
                        <div class="subtitle" innerHTML="{{ 'forms-Phone-Number-Input' | translation | async }}"></div>
                        <app-copy-to-clipboard [value]="rc_number"></app-copy-to-clipboard>
                    </app-counter-item>
                    <app-counter-item [number]="2">
                        <p innerHTML="{{ 'sinpe-Movil-Step-Two' | translation | async }}"></p>
                        <div class="subtitle" innerHTML="{{ 'reference' | translation | async }}"></div>
                        <app-copy-to-clipboard [value]="transaction.ORDER_REFERENCE"></app-copy-to-clipboard>
                    </app-counter-item>
                    <app-counter-item>
                      <p innerHTML="{{ 'sinpe-movil-contact-label' | translation | async }}" ></p>
                      <p>{{ 'sinpe-movil-email' | translation | async }}<a class="info-link" href="mailto:{{emailTo}}">{{emailTo}}</a></p>
                      <p>{{ 'sinpe-movil-whatsapp-label' | translation | async }}
                        <a class="info-link" href="https://api.whatsapp.com/send?phone={{whatsappNumberInfo}}">{{formatWhatsAppNumber(whatsappNumberInfo)}}
                          <img [src]="whatsapp_logo" alt="">
                        </a>
                      </p>
                      <br>
                      <p innerHTML="{{ 'cash-aprovetime-sinpe-movil' | translation | async }}"></p>
                    </app-counter-item>
                </div>
            </div>
        </div>
    </div>
    </ng-container>
    <ng-template #oldSinpeMovil>
      <div class="contentBox">
        <div class="center col-3">
            <div class="info-logo-container">
                <img [src]="information.logo" class="payment_method_no_interactive __method_brands" alt="sinpe-logo" />
            </div>
        </div>
        <div class="col-7">
            <div class="methodInfo">
                <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD"
                    (RT)="changeMethod()">
                </app-return-methods>
                <h1>{{ 'transferTitle' | translation | async }}</h1>
                <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
                <div class="steps">
                    <app-counter-item [number]="1">
                        <p innerHTML="{{ 'sinpe-Movil-Step-One' | translation | async }}"></p>
                        <div class="subtitle" innerHTML="{{ 'forms-Phone-Number-Input' | translation | async }}"></div>
                        <app-copy-to-clipboard [value]="rc_number"></app-copy-to-clipboard>
                    </app-counter-item>
                    <app-counter-item [number]="2">
                        <p innerHTML="{{ 'sinpe-Movil-Step-Two' | translation | async }}"></p>
                        <div class="subtitle" innerHTML="{{ 'reference' | translation | async }}"></div>
                        <app-copy-to-clipboard [value]="transaction.ORDER_REFERENCE"></app-copy-to-clipboard>
                    </app-counter-item>
                    <app-counter-item [number]="3">
                        <p>{{ 'deposit-EmailInfo' | translation | async }}</p>
                        <form [formGroup]="emailForm">
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'forms-Email-Input' | translation | async }}</mat-label>
                                <input type="text" matInput name="email"
                                    placeholder="{{ 'forms-Email-Input' | translation | async }}"
                                    maxlength="150"
                                    minlength="10"
                                    formControlName="email" />
                            </mat-form-field>
                            <ng-container *ngFor="let validation of errorsMessages.email">
                                <div class="error-message" *ngIf="emailForm.get('email').hasError(validation.type) &&
                                            (emailForm.get('email').dirty ||
                                            emailForm.get('email').touched)">
                                    {{ validation.message }}
                                </div>
                            </ng-container>
                        </form>
                    </app-counter-item>
                </div>
                <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
                <p innerHTML="{{ 'cash-AproveTime' | translation | async }}"></p>
            </div>
            <app-buttons-bar [valid]="completedForms()" [template]="template"
                [nameCustom]="buttonMessage | translation | async" class="payButton" (CUSTOM)="sendEmail()">
            </app-buttons-bar>
        </div>
    </div>
    </ng-template>
</section>
